import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui';
export const Trainers = () => {
  return <section id="despre" className="py-24 bg-navy relative overflow-hidden" data-id="element-461">
      <div className="container mx-auto px-6" data-id="element-462">
        <div className="grid lg:grid-cols-2 gap-16 items-center" data-id="element-463">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="relative h-[350px] lg:h-[750px] order-2 lg:order-1" data-id="element-464">
            {/* Main photo container - full width */}
            <div className="relative w-full h-full bg-navy border border-gold/20 overflow-hidden" data-id="element-465">
              <img src="https://cdn.magicpatterns.com/uploads/ghLHAPseTVyhqMFRdoxXFY/Marius_si_Ana_1.jpg" alt="Marius și Ana Cernea" className="w-full h-full object-cover object-top opacity-90" data-id="element-466" />
              <div className="absolute inset-0 bg-gradient-to-t from-navy via-transparent to-transparent" data-id="element-467" />
            </div>
            {/* Decorative corner borders */}
            <div className="absolute -bottom-6 -left-6 w-32 h-32 border-l border-b border-gold/50" data-id="element-468" />
            <div className="absolute -top-6 -right-6 w-32 h-32 border-r border-t border-gold/50" data-id="element-469" />
            {/* Decorative floating circle top-left */}
            <div className="absolute -top-10 -left-10 w-24 h-24 rounded-full border border-gold/20" data-id="element-470" />
            {/* Decorative dots pattern */}
            <div className="absolute top-8 -right-12 opacity-30" data-id="element-471">
              <svg width="80" height="80" viewBox="0 0 80 80" fill="none" data-id="element-472">
                {[0, 20, 40, 60].map(x => [0, 20, 40, 60].map(y => <circle key={`${x}-${y}`} cx={x + 10} cy={y + 10} r="2" fill="#C9A84C" data-id="element-473" />))}
              </svg>
            </div>
          </motion.div>
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="order-1 lg:order-2" data-id="element-474">
            <h2 className="font-serif text-4xl md:text-5xl font-bold text-white mb-10" data-id="element-475">
              Cine suntem noi și de ce am creat acest program
            </h2>
            <div className="space-y-6 font-sans text-white text-xl leading-relaxed" data-id="element-476">
              <p data-id="element-477">
                Suntem Marius și Ana Cernea, traineri NLP și practicieni în
                psihologie aplicată, comunicare nonverbală și profilare
                comportamentală. Lucrăm cu antreprenori, lideri, sportivi de
                performanță, psihologi, medici și oameni care vor să se
                înțeleagă mai bine pe ei înșiși și să comunice mai bine cu
                ceilalți.
              </p>
              <p data-id="element-478">
                De-a lungul anilor am lucrat cu sute de oameni care știau
                teoria, dar nu știau de ce nu schimbă nimic. Am văzut oameni
                capabili blocați de tipare vechi, de amintiri nedecantate, de
                convingeri pe care nici nu le conștientizau. Și am văzut aceiași
                oameni transformați, după ce au înțeles cum funcționează mintea
                lor.
              </p>
              <p data-id="element-479">
                NLP Practitioner este programul pe care l-am construit din
                această experiență directă. Nu este un curs despre concepte
                frumoase. Este un antrenament practic în care înveți să îți
                folosești mintea ca aliat, nu ca sabotor. Fiecare modul are
                exerciții reale, feedback direct și aplicare imediată.
              </p>
              <p data-id="element-480">
                Aducem în sală nu doar cunoaștere, ci și experiența de a lucra
                cu oameni din domenii și contexte foarte diferite. Asta înseamnă
                că înțelegem că fiecare are propriul ritm, propriile blocaje și
                propriul mod de a procesa informația.
              </p>
            </div>
            <div className="mt-10" data-id="element-481">
              <Button data-id="element-482">Scrie-mi pe WhatsApp pentru detalii!</Button>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
};